/**
 * Activity Queue / ding eligibility for Kai hourly upline digest messages.
 */

export function isHourlyUplineDigestMessageData(messageData) {
    if (!messageData || messageData.sub_type !== "agent_response") {
        return false;
    }

    if (messageData.hourly_upline_digest === true) {
        return true;
    }

    const subjectId = Number(messageData.digest_subject_user_profile_id);

    return Number.isFinite(subjectId) && subjectId > 0;
}

/**
 * @param {{ usr_profile_logged_time?: object[] }|null|undefined} appState
 * @returns {Set<number>}
 */
export function getWorklineVisibleProfileIds(appState) {
    const rows = appState?.usr_profile_logged_time;
    const ids = new Set();

    if (!Array.isArray(rows)) {
        return ids;
    }

    for (const row of rows) {
        const profileId = Number(row?.user_profile_id ?? row?.employee_id);
        if (Number.isFinite(profileId) && profileId > 0) {
            ids.add(profileId);
        }
    }

    return ids;
}

/**
 * Whether an hourly upline digest should increment AQ and play a ding.
 *
 * @param {object|null|undefined} messageData
 * @param {{ usr_profile_logged_time?: object[] }|null|undefined} appState
 */
export function isHourlyDigestSubjectVisibleOnWorkline(messageData, appState) {
    const subjectId = Number(messageData?.digest_subject_user_profile_id);
    if (!Number.isFinite(subjectId) || subjectId <= 0) {
        return false;
    }

    return getWorklineVisibleProfileIds(appState).has(subjectId);
}
